import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderCancellationRequestImplEncoder } from "../../encoder/OrderCancellationRequestImplEncoder";

import * as CubiqTS from "../../index";
import { OrderCancellationRequest } from "../OrderCancellationRequest";

export class OrderCancellationRequestImpl
  extends ConcreteEncodable
  implements OrderCancellationRequest
{
  public static enType: string = "com.bcdfx.model.event.OrderCancellationRequestImpl";

  /*FID=1*/
  public orderIds: Array<string> | null = null;
  /*FID=2*/
  public reason: string;
  /*FID=4*/
  public tradingChannel: string;
  /*FID=16*/
  public oboUser: string;
  /*FID=17*/
  public ptpComposites: Array<CubiqTS.OrderPTPComposite> | null = null;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OrderCancellationRequestImplEncoder.Instance;
    this.setEncodableType(OrderCancellationRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "OrderCancellationRequestImpl[" +
      "orderIds=" +
      this.orderIds +
      "reason=" +
      this.reason +
      "tradingChannel=" +
      this.tradingChannel +
      "oboUser=" +
      this.oboUser +
      "ptpComposites=" +
      this.ptpComposites +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
